import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";

function Block4() {

    return (
            <section className="home22-cta-2 at-home19 layout-pb-60">
                <div className="auto-container">
                    <div className="row d-flex align-items-stretch">

                        <div className="image-content wow fadeInLeft col-xl-6 pe-0 d-flex justify-content-center align-items-center" style={{flex: "1"}}>
                            <img src="/images/resource/support-client.png" alt="support-client" className="homepage" style={{maxWidth: "100%", height: "100%", objectFit: "cover"}} />
                        </div>

                        <div className="content-column wow fadeInRight col-xl-6 homepage">
                            <div className="inner-column">
                                <div className="mb-0">
                                    <h2 className="title homepage left mb50">Un accompagnement complet, de A à Z</h2>
                                    <p className="text-white">Une prise en charge complète pour vous garantir
                                        des webinaires efficaces, simples à déployer et utiles pour vos équipes.</p>
                                    <ul className="list-style-one at-home19 homepage mt20">
                                        <li>Organisation et préparation clés en main du webinaire et de son support</li>
                                        <li>Mise en ligne du webinaire dans un espace dédié (programme, inscriptions…)</li>
                                        <li>Kit de communication interne</li>
                                        <li>Réponses aux questions des collaborateurs pendant le webinaire</li>
                                        <li>Livret « L’essentiel à retenir » après le webinaire</li>
                                        <li>Replay (usage interne pendant 3 mois)</li>
                                        <li>Accès au jeu « L’Académie de l’inclusion »</li>
                                    </ul>

                                    <ContactModal textButton="Demander une présentation personnalisée" showText={false} small="small" linkPageContact={false} iframe={false} couleur={true} formModal={true}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default Block4;
